<div class="container">

  <app-header-dialog [iconName]="'store_mall_directory'">
    Pastas
  </app-header-dialog>

  <div class='content'>

    <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.name.hasError('required')">
          O nome é obrigatório
        </mat-error>
      </mat-form-field>

    </form>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button mat-raised-button class="flat-button" mat-dialog-close (click)="matDialogRef.close([ 'add', entityForm ])"
      *ngIf="!isEdit" [disabled]="entityForm.invalid">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button mat-raised-button class="flat-button" mat-dialog-close (click)="matDialogRef.close([ 'edit', entityForm ])"
      *ngIf="isEdit" [disabled]="entityForm.invalid">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>